import { useAxios } from '../Plugins/axios';
import { useRoute } from '../Plugins/ziggy';
export var ForecastType;
(function (ForecastType) {
    ForecastType["Daily"] = "daily";
    ForecastType["Hourly"] = "hourly";
})(ForecastType || (ForecastType = {}));
export class WeatherForecastService {
    axios;
    route;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
    }
    get(lat, lon, type) {
        return this.axios.get(this.route('api.weather.forecast', {
            lat,
            lon,
            type,
        }));
    }
}
